import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { COPY } from './copy';
import { SECTIONS } from './copy-sections';
import { DEFAULT_PUBLIC_LOCALE, isPublicLocale, localizedPath, type PublicLocale } from '@/seo/site';

/** [#e03fdbc2] Язык публичной страницы берётся из адреса, поэтому совпадает с готовым HTML. */
export function usePublicPage() {
  const route = useRoute();
  const locale = computed<PublicLocale>(() => (isPublicLocale(route.params.locale) ? route.params.locale : DEFAULT_PUBLIC_LOCALE));
  const copy = computed(() => COPY[locale.value]);
  const more = computed(() => SECTIONS[locale.value]);
  const to = (path: string) => localizedPath(path, locale.value);
  return { locale, copy, more, to };
}
